export const PARAMS_KEYS_FOR_TESTING_NODE = ['to'];

export const TRANSACTIONAL_EMAIL_DOCS_URL = 'https://docs.ply.io/build-features/helpers/transactional-emails';

export const VerificationEmailTypes = {
	REPLY_TO: 'reply_to',
	UNSUBSCRIBE_CONTACT: 'unsubscribe_contact',
};
